<template>
    <div class="benefit-card">
        <div class="head-nav-box">
            <div class="nav-back" @click="goBack"></div>
            <div class="nav-title">全部权益</div>
        </div>
        <div class="swiper-cards-box">
            <swiper :options="swiperOption" class="swiper" ref="mySwiper">
                <swiper-slide v-for="item in levelList" :key="item.level">
                    <div class="card-item" :class="{'dark-mask': item.levelIndex > currentLevelIndex}">
                        <div class="desc">
                            <div>
                                {{
                                    item.levelIndex === currentLevelIndex ? '当前活力值' : '活力值'
                                }}
                            </div>
                            <div class="vip-icon" :class="{'locked-vip': item.levelIndex > currentLevelIndex}">
                                <div class="vip-num">{{ item.levelIndex }}</div>
                            </div>
                        </div>
                        <div class="score-num">
                            {{
                                item.levelIndex === currentLevelIndex
                                    ? benefitInfo.totalScore
                                    : item.scoreSection
                            }}
                        </div>
                        <div class="vip-tag" v-if="item.levelIndex === currentLevelIndex">
                            当前等级
                        </div>
                        <div class="level-num">{{ item.levelIndex }}</div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <div class="level-bar-box">
            <div
                class="bar-container"
                :style="{ width: `${barBoxWidth}px`, left: `${barPositionLeft}px` }"
            >
                <div class="total-bar">
                    <div class="highlight" :style="{ width: `${highlightWidth}px` }"></div>
                </div>
                <div
                    class="level-item"
                    :style="{ left: `${calcLevelItemLeft(index)}px` }"
                    v-for="(item, index) in levelList"
                    :key="item.level"
                >
                    <img
                        v-if="item.levelIndex <= currentLevelIndex"
                        src="../../../../assets/iconV4.0/icon-level-done@2x.png"
                        alt=""
                    />
                    <img v-else src="../../../../assets/iconV4.0/icon-level-todo@2x.png" alt="" />
                    <div
                        class="leveltext"
                        :class="{ darkcolor: item.levelIndex <= currentLevelIndex }"
                    >
                        {{ item.level }}
                    </div>
                </div>
            </div>
        </div>
        <div class="task-box">
            <div class="text" id="idTaskBtn">
                <!-- 最高等级Vmax -->
                <template v-if="isHighestLevel">
                    <span>已解锁全部权益，请继续保持等级</span>
                </template>
                <!-- Vn+2~Vmax-1 -->
                <template v-else-if="curCardIndex > (currentLevelIndex + 1)">
                    <span>V{{ curCardIndex }}等级解锁</span>
                    <span class="orange-bold">{{ lockInfo.diff || 0 }}</span>
                    <span>项新权益，活力值需达到</span>
                    <span class="orange-bold">{{ lockInfo.requireScore || 0 }}</span>
                </template>
                <!-- V1~Vn+1 -->
                <template v-else>
                    <span>还需</span>
                    <span class="orange-bold">{{ nextLevelScore }}</span>
                    <span>活力值可升级，解锁</span>
                    <span class="orange-bold">{{ lockInfo.diff || 0 }}</span>
                    <span>项新权益</span>
                </template>
            </div>
            <div class="button" @click="onTaskClick">做任务</div>
        </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
const c_swiper = document.getElementsByClassName('swiper');
export default {
    components: {
        Swiper,
        SwiperSlide
    },
    props: {
        benefitInfo: {
            type: Object,
            default: () => {}
        },
        isHighestLevel: {
            type: Boolean,
            default: false
        },
        lockInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            screenWidth: screen.width,
            screenHeight: screen.height,
            curCardIndex: 1,
            swiperOption: {
                centeredSlides: true, // 当前的active slide会居中
                slidesPerView: 'auto', // 同时显示的slides数量
                spaceBetween: 10, // 在slide之间设置距离（单位px）
                initialSlide: 0, // 初始化时slide的索引
                on: {
                    slideChangeTransitionEnd: () => {
                        this.curCardIndex = c_swiper[0].swiper.activeIndex + 1;
                        this.$emit('onCardSlide', this.curCardIndex);
                    }
                }
            }
        };
    },
    computed: {
        levelList() {
            return this.benefitInfo.scoreSectionList || [];
        },
        currentLevelIndex() {
            return this.benefitInfo.currentLevelIndex || 1;
        },
        // V1~Vn+1，还需活力值解锁下一等级
        nextLevelScore() {
            let nextScore = this.benefitInfo.nextScoreSection || 0;
            let nowScore = this.benefitInfo.totalScore || 0;
            return nextScore - nowScore;
        },
        // 进度条平移位置
        barPositionLeft() {
            // 3时左边位移18，4时18减去81，5时18减去2*81，...
            return Math.round(((18 - (this.curCardIndex - 3) * 81) * this.screenWidth) / 375);
        },
        // 进度条总宽度
        barBoxWidth() {
            return Math.round(((81 * this.levelList.length - 65) * this.screenWidth) / 375);
        },
        // 进度条高亮宽度
        highlightWidth() {
            // 0时宽0，1时加上额外比例所占宽度，2时81加上额外比例所占宽度，...
            const { totalScore, currentScoreSection, nextScoreSection } = this.benefitInfo;
            let extraRate =
                (totalScore - currentScoreSection) / (nextScoreSection - currentScoreSection);
            extraRate = this.isHighestLevel ? 0 : extraRate;
            return Math.round(
                ((this.currentLevelIndex - 1 + extraRate) * 81 * this.screenWidth) / 375
            );
        }
    },
    watch: {
        currentLevelIndex: {
            immediate: true,
            handler: function(newV) {
                let level = newV || 1;
                if (c_swiper[0]) {
                    c_swiper[0].swiper.activeIndex = level - 1;
                    this.curCardIndex = level;
                }
            }
        }
    },
    methods: {
        calcLevelItemLeft(index) {
            return Math.round((index * 81 * this.screenWidth) / 375);
        },
        onTaskClick() {
            let btnText = document.getElementById('idTaskBtn').innerText || '';
            this.$emit('onButtonClick', btnText);
        },
        goBack() {
            this.$emit('onBackClick');
        }
    }
};
</script>

<style lang="less" scoped>
@asserts: '../../../../assets/iconV2.5/';
@asserts_4_0: '../../../../assets/iconV4.0/';
.benefit-card {
    width: 375px;
    background: linear-gradient(
        180deg,
        #76b6f8 0%,
        rgba(109, 171, 232, 0.37) 35%,
        rgba(156, 204, 245, 0.32) 100%
    );
    .head-nav-box {
        position: relative;
        text-align: center;
        padding: 53px 10px 33px 10px;
        height: 110px;
        .nav-back {
            position: absolute;
            width: 24px;
            height: 24px;
            background-size: 100% 100%;
            background-image: url('@{asserts}/goback-icon@2x.png');
        }
        .nav-title {
            line-height: 24px;
            font-size: 18px;
            color: #ffffff;
            font-family: FZLTZHK--GBK1-0, FZLTZHK--GBK1;
        }
    }
    .swiper-cards-box {
        height: 159px;
        .swiper-slide {
            width: 335px;
            height: 159px;
        }
        .card-item {
            width: 335px;
            height: 159px;
            background-size: 100% 100%;
            background-image: url('@{asserts_4_0}/bg-benefit-card@2x.png');
            padding: 30px 20px;
            position: relative;
            &.dark-mask::before {
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 10px;
                background: rgba(0, 0, 0, 0.6);
                opacity: 0.3;
                border-radius: 9px;
            }
            &.dark-mask::after {
                content: '';
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: -8px;
                width: 0;
                height: 0;
                border: 9px solid transparent;
                border-top-color: rgba(0, 0, 0, 0.6);
                opacity: 0.3;
            }
            .desc {
                height: 18px;
                line-height: 18px;
                font-size: 13px;
                font-weight: 400;
                color: #fff5e4;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
            }
            .vip-icon {
                width: 27px;
                height: 21px;
                background-size: 100% 100%;
                background-image: url('@{asserts_4_0}/icon-V-yellow@2x.png');
                margin-left: 3px;
                padding-left: 16px;
                padding-top: 6px;
                &.locked-vip {
                    width: 46px;
                    background-image: url('@{asserts_4_0}/icon-V-locked@2x.png');
                    padding-left: 32px;
                    .vip-num {
                        color: #cb7000;
                    }
                }
                .vip-num {
                    font-size: 12px;
                    transform: scale(0.75);
                    transform-origin: 0 0;
                    font-weight: 600;
                    color: #f88800;
                    line-height: 15px;
                }
            }
            .score-num {
                line-height: 43px;
                font-size: 36px;
                font-family: uni_sans_regular;
                font-weight: 400;
                color: #ffffff;
                margin-top: 9px;
            }
            .vip-tag {
                position: absolute;
                top: 0;
                right: 0;
                width: 62px;
                height: 25px;
                background-size: 100% 100%;
                background-image: url('@{asserts_4_0}/bg-vip-orange@2x.png');
                text-align: center;
                line-height: 25px;
                font-size: 12px;
                font-weight: 400;
                color: #b26200;
            }
            .level-num {
                position: absolute;
                bottom: 6px;
                right: 24px;
                line-height: 50px;
                font-size: 45px;
                font-weight: 600;
                color: #ffffff;
                opacity: 0.1;
            }
        }
    }
    .level-bar-box {
        width: 375px;
        height: 59px;
        overflow: hidden;
        .bar-container {
            width: 0;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            transition: all 0.5s;
            .total-bar {
                position: absolute;
                left: 0;
                right: 0;
                top: 9px;
                height: 4px;
                background: linear-gradient(53deg, #b9d4ee 0%, #b5d3ee 100%);
                border-radius: 2px;
                .highlight {
                    width: 0;
                    height: 4px;
                    background: linear-gradient(270deg, #f89a3e 0%, #ffb960 100%);
                    border-radius: 2px;
                }
            }
            .level-item {
                position: absolute;
                top: 2px;
                left: 0;
                img {
                    width: 16px;
                    height: 16px;
                }
                .leveltext {
                    height: 18px;
                    line-height: 18px;
                    font-size: 13px;
                    font-weight: 600;
                    color: #6688aa;
                    margin-top: 1px;
                    opacity: 0.5;
                    &.darkcolor {
                        color: #39434e;
                        opacity: 1;
                    }
                }
            }
        }
    }
    .task-box {
        height: 29px;
        padding: 0px 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .text {
            font-size: 13px;
            font-weight: 400;
            color: #002a3c;
            .orange-bold {
                color: #dc6d39;
                font-weight: 600;
            }
        }
        .button {
            width: 72px;
            height: 29px;
            background: #4a9bef;
            border-radius: 15px;
            font-size: 13px;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 29px;
        }
    }
}
</style>